var map = {
	"./gem.png": 32,
	"./goose-shrunk.png": 33,
	"./goose.png": 34,
	"./mmc.png": 35,
	"./nextroll.png": 36,
	"./qts.png": 37,
	"./sap.png": 38,
	"./shareworks.png": 39,
	"./shareworks.svg": 40,
	"./shopify.png": 41,
	"./uw.svg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;